import React, { useEffect, useState, useRef, useCallback } from 'react';
import {
  Table,
  Button,
  Dialog,
  Input,
  Form,
  DatePicker,
  CascaderSelect,
  Message,
  Tag,
  Select,
  Pagination,
  Card,
} from '@alifd/next';
import moment from 'moment';
import axios from 'axios';
import 'antd/dist/antd.css';
import BarcodeReader from 'react-barcode-reader';
import Swal from 'sweetalert2';
import Webcam from 'react-webcam';
import { element, func } from 'prop-types';
import { Image } from 'antd';
import ezconImg from '../../../../../public/ezcon.png';
import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const Option = Select.Option;
const { Item } = Form;
const RealEstateAgentManagementList = (props) => {
  const currentDate = moment();
  const localeData = currentDate.clone().localeData(); // currentDate

  const users = client.service('users');
  const visitorAppointmentRegistration = client.service(
    'visitorAppointmentRegistration'
  );
  const residentAccountNumbers = client.service('residentAccountNumbers');
  const cardManagement = client.service('cardManagement');
  const [residentAccountNumbersArr, setResidentAccountNumbersArr] = useState(
    []
  );
  const [visitorAppointmentArr, setVisitorAppointmentArr] = useState([]);
  const [reservationTimeStart, setReservationTimeStart] = useState(
    moment().format('YYYY-MM-DD HH:mm:ss')
  );
  const [visitorsName, setVisitorsName] = useState('');
  const [visitorsPhone, setVisitorsPhone] = useState('');
  const [householdNumber, setHouseholdNumber] = useState(''); // 戶號
  const [residentNameArr, setResidentNameArr] = useState([]); // 該戶號成員姓名
  const [residentName, setResidentName] = useState(''); // 選到該戶號成員姓名
  const [tarUserId, setTarUserId] = useState(''); // 選到該戶成員userId
  const [intervieweeRemarks, setIntervieweeRemarks] = useState('');
  const [temperature, setTemperature] = useState('');
  const [carNumber, setCarNumber] = useState('');
  const [visitingReason, setVisitingReason] = useState('');
  const [peopleNumber, setPeopleNumber] = useState(1);
  const [takeCardStatus, setTakeCardStatus] = useState('未領卡'); // 取卡狀態
  const [visitorsStatus, setVisitorsStatus] = useState('預約中'); // 房仲狀態
  const [takeCardLost, setTakeCardLost] = useState('否'); // 房仲卡遺失
  const [searchVisitorsCardNumber, setSearchVisitorsCardNumber] = useState('');
  const [searchVisitorsName, setSearchVisitorsName] = useState('');
  const [cardStatus, setCardStatus] = useState('');

  const [addVisitorDialog, setAddVisitorDialog] = useState(false);
  const [editVisitorDialog, setEditVisitorDialog] = useState(false);
  const [takeCardDialog, setTakeCardDialog] = useState(false);
  const [cancleDialog, setCancleDialog] = useState(false);
  const [leaveDialog, setLeaveDialog] = useState(false);
  const [editVisitorIndex, setEditVisitorIndex] = useState('');
  const [takeCardIndex, setTakeCardIndex] = useState('');
  const [cancleIndex, setCancleIndex] = useState('');
  const [leaveIndex, setLeaveIndex] = useState('');

  // 進場取卡片

  const [cardOrderNumber, setCardOrderNumber] = useState(''); // 卡片流水號
  const [cardNumbering, setCardNumbering] = useState(''); // 卡片編號
  const [cardNotes, setCardNotes] = useState(''); // 卡片備註
  const [cardNumber, setCardNumber] = useState(''); // 卡號

  // 房仲離開
  const [leaveArr, setLeaveArr] = useState([]);
  const [leaveArr1, setLeaveArr1] = useState([]);

  // webcam
  const [webcamDialog, setWebcamDialog] = useState(false);
  const [webcamRemarksDialog, setWebcamRemarksDialog] = useState(false);
  const [webcamEditDialog, setWebcamEditDialog] = useState(false);
  const [webcamEditRemarksDialog, setWebcamEditRemarksDialog] = useState(false);

  const [curdataIndex, setcurDataIndex] = useState('reservationTimeStart');
  const [curorder, setcurOrder] = useState('desc');
  const currentDate1 = moment().subtract(1, 'days');

  // 換頁預約
  const [postsPerPage] = useState(10);

  const [currentInPage, setCurrentInPage] = useState(1);
  const indexOfLastPostIn = currentInPage * postsPerPage;
  const indexOfFirstPostIn = indexOfLastPostIn - postsPerPage;
  const currentPostsIn = visitorAppointmentArr.slice(
    indexOfFirstPostIn,
    indexOfLastPostIn
  );

  const [currentOutPage, setCurrentOutPage] = useState(1);
  const indexOfLastPostOut = currentOutPage * postsPerPage;
  const indexOfFirstPostOut = indexOfLastPostOut - postsPerPage;
  const currentPostsOut = leaveArr.slice(
    indexOfFirstPostOut,
    indexOfLastPostOut
  );

  const [currentLeavePage, setCurrentLeavePage] = useState(1);
  const indexOfLastPostLeave = currentLeavePage * postsPerPage;
  const indexOfFirstPostLeave = indexOfLastPostLeave - postsPerPage;
  const currentPostsLeave = leaveArr1.slice(
    indexOfFirstPostLeave,
    indexOfLastPostLeave
  );

  // residentAccountNumbers
  async function funFindResident(para) {
    const result = await residentAccountNumbers.find({ query: para });
    return result && result.data ? result.data : [];
  }

  function householdNumberSort(a, b) {
    return a.building > b.building
      ? 1
      : -1 && parseInt(a.floor) > parseInt(b.floor)
      ? 1
      : -1 && parseInt(a.floorChild) > parseInt(b.floorChild)
      ? 1
      : -1;
  }

  function serverResidentDataUpdate() {
    funFindResident({}).then((result) => {
      setResidentAccountNumbersArr(result.sort(householdNumberSort));
    });
  }
  useEffect(() => {
    serverResidentDataUpdate();
  }, []);

  // visitor預約中
  async function funFindVisitor() {
    const DAY_MS = 24 * 60 * 60 * 1000 * 365;
    const result = await visitorAppointmentRegistration.find({
      query: {
        type: 'agent',
        $sort: {
          reservationTimeStart: -1,
        },
        reservationTimeStart: {
          $gt: moment().startOf('day').valueOf(), // 今天之後
          $lt: moment().valueOf() + DAY_MS, // 以今天計算+365天
        },
        visitorsStatus: { $nin: ['已取消', '已入場', '已離場'] },
      },
    });
    return result && result.data ? result.data : [];
  }
  async function funCreateVisitor(obj) {
    await visitorAppointmentRegistration.create({ ...obj, type: 'agent' });
  }
  async function funUpdateVisitor(id, obj) {
    await visitorAppointmentRegistration.patch(id, obj);
  }
  async function funRemoveVisitor(id) {
    await visitorAppointmentRegistration.remove(id);
  }

  function ordersort(a, b) {
    return a.reservationTimeStart > b.reservationTimeStart ? 1 : -1;
  }
  function serverVisitorDataUpdate() {
    funFindVisitor().then((result) => {
      setVisitorAppointmentArr(result);
    });
  }
  useEffect(() => {
    serverVisitorDataUpdate();
    // funSortUpdate();
  }, []);

  // 今日尚未離開房仲-撈全部
  async function funFindLeave() {
    const result = await visitorAppointmentRegistration.find({
      query: {
        type: 'agent',
        visitorsStatus: { $nin: ['已取消', '預約中', '已離場'] },
      },
    });
    return result && result.data ? result.data : [];
  }
  function serverLeaveDataUpdate() {
    funFindLeave().then((result) => {
      setLeaveArr(result.sort(ordersort));
    });
  }
  useEffect(() => {
    serverLeaveDataUpdate();
    // funSortUpdate();
  }, []);

  // 今日已離開離開房仲
  async function funFindLeave1() {
    const result = (
      await visitorAppointmentRegistration.find({
        query: {
          type: 'agent',
          visitorsStatus: { $nin: ['已取消', '預約中', '已入場'] },
        },
      })
    ).data.filter(
      (x) => moment(x.leaveTime).format('YYYYMMDD') === sCurrentDate
    );
    return result || [];
  }

  function serverLeaveDataUpdate1() {
    funFindLeave1().then((result) => {
      setLeaveArr1(result.sort(ordersort));
    });
  }
  useEffect(() => {
    serverLeaveDataUpdate1();
    // funSortUpdate();
  }, []);

  // const dataSource = [];

  // for (let i = 0; i < residentAccountNumbersArr.length; i++) {
  //   //第一層
  //   let building = residentAccountNumbersArr[i].building;
  //   let objBuilding = dataSource.find((item) => item.label === building);
  //   if (!objBuilding) {
  //     objBuilding = {
  //       value: `${building}`,
  //       label: `${building}`,
  //       children: [],
  //     };
  //     dataSource.push(objBuilding);
  //   }
  //   //第二層
  //   let floor = residentAccountNumbersArr[i].floor;
  //   let objFloor = objBuilding.children.find((item) => item.label === floor);
  //   if (!objFloor) {
  //     objFloor = {
  //       value: `${building}-${floor}`,
  //       label: `${floor}`,
  //       children: [],
  //     };
  //     objBuilding.children.push(objFloor);
  //   }

  //   //第三層
  //   let floorChild = residentAccountNumbersArr[i].floorChild;
  //   let objFloorChild = dataSource.find((item) => item.label === floorChild);
  //   if (!objFloorChild) {
  //     objFloorChild = {
  //       value: `${building}-${floor}-${floorChild}`,
  //       label: `${floorChild}`,
  //     };
  //     objFloor.children.push(objFloorChild);
  //   }
  //   // console.log(`==${i}th dataSource:`,dataSource)
  // }
  // 戶號選單
  function ParseStringToArrayObject() {
    // 戶號拆解
    const data = residentAccountNumbersArr.map((i) =>
      i.householdNumber.split('-')
    );
    let Stages = [];
    function iter(e, si = 1) {
      const va = e.slice(0, si).join('-');
      if (!Stages.includes(va)) Stages.push(va);
      if (e[si]) iter(e, si + 1);
    }
    data.forEach((e) => {
      iter(e);
    });
    Stages = Stages.sort((a, b) => {
      return a.length - b.length;
    });
    const newStages = {};
    Stages.forEach((e) => {
      // (e.length==1)newStages[e] = [e];
      if (e.indexOf('-') == -1) newStages[e] = [e];
      else {
        const theDashNb = e.indexOf('-');
        // newStages[e.slice(0,1)].push(e);
        newStages[e.slice(0, theDashNb)].push(e);
      }
    });
    const FinalData = [];
    Object.keys(newStages).forEach((e) => {
      // { A:['A','A-1'],B:['B','B-1','B-1-1']...}
      const childsObj = {};
      newStages[e].forEach((ee, nb) => {
        let tempTarLabel = ee;
        if (ee.indexOf('-') >= 0) {
          const tempArrChild = ee.split('-');
          tempTarLabel = tempArrChild[tempArrChild.length - 1];
        }
        childsObj[ee] = {
          // 'label': ee.indexOf("-")==-1? ee : ee.slice(ee.length-1,ee.length),
          label: tempTarLabel,
          value: ee,
        };
      });
      newStages[e].reverse().forEach((ee, nb) => {
        // 底層開始 => 加入到上一層children
        // if(ee.length>=3){
        if (ee.indexOf('-') != -1) {
          const tempArrChild = ee.split('-');
          // const ky = ee.slice(0,ee.length-2);
          const ky = tempArrChild.slice(0, tempArrChild.length - 1).join('-');
          if (!childsObj[ky].children) {
            // 加入到上一層children
            childsObj[ky].children = [childsObj[ee]];
          } else {
            childsObj[ky].children.push(childsObj[ee]);
            childsObj[ky].children.sort((a, b) => {
              return a.label - b.label;
            }); // label小－大
          }
        }
      });
      FinalData.push(childsObj[Object.keys(childsObj)[0]]); // 只取最上層(第一比obj)(資料已經都加到第一比)
    });
    // console.log(FinalData);
    return FinalData;
  }

  // 今日尚未離開的房仲
  let sCurrentDate = moment(currentDate).format('YYYYMMDD');
  // console.log(sCurrentDate )
  const currentDateAdmission = leaveArr.filter(
    (x) => moment(x.admissionTime).format('YYYYMMDD') === sCurrentDate
  );
  // 今日離開的房仲

  const currentDateLeave = leaveArr1.filter(
    (x) => moment(x.leaveTime).format('YYYYMMDD') === sCurrentDate
  );

  // 房仲卡號搜尋
  let serachVisitorApproachArr = currentPostsOut;
  serachVisitorApproachArr = currentPostsOut.filter(
    (x) => x.cardNumber === searchVisitorsCardNumber
  );
  let serachVisitorAppointmentArr = currentPostsIn;
  serachVisitorAppointmentArr = currentPostsIn.filter(
    (x) => x.cardNumber === searchVisitorsCardNumber
  );
  let serachVisitorLeaveArr = currentPostsLeave;
  serachVisitorLeaveArr = currentPostsLeave.filter(
    (x) => x.cardNumber === searchVisitorsCardNumber
  );

  let serachVisitorApproachNameArr = currentPostsOut;
  serachVisitorApproachNameArr = currentPostsOut.filter((x) =>
    x.visitorsName.match(
      searchVisitorsName.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\@\.]/g, '')
    )
  );

  let serachVisitorAppointmentNameArr = currentPostsIn;
  serachVisitorAppointmentNameArr = currentPostsIn.filter((x) =>
    x.visitorsName.match(
      searchVisitorsName.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\@\.]/g, '')
    )
  );
  let serachVisitorLeaveNameArr = currentPostsLeave;
  serachVisitorLeaveNameArr = currentPostsLeave.filter((x) =>
    x.visitorsName.match(
      searchVisitorsName.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\@\.]/g, '')
    )
  );

  // 以下是房仲拍照
  const webcamRef = useRef(null);
  const [visitorPhoto, setVisitorPhoto] = useState(null);
  const [visitorRemarkPhoto, setVisitorRemarkPhoto] = useState(null);

  const [devices, setDevices] = useState([]);
  // console.log(devices)

  // devices 所有資訊可能1種以上裝置
  // [InputDeviceInfo]0:
  // InputDeviceInfodeviceId: "a55c78c668caa1c14d485fbcf94eac2e79bbab34ea2c7497589f496d87aa5e00"
  // groupId: "004cba647b1865459283d469b8ffbce8cacddb9413865e91bb0dfbb66f5601b9"
  // kind: "videoinput"label:
  // "FaceTime HD攝影機（內建） (05ac:8600)
  // "__proto__: InputDeviceInfolength: 1__proto__: Array(0)

  // 取得devices =>InputDeviceInfo 陣列
  const [devicesVal, setDevicesVal] = useState([]);
  // console.log(devicesVal)

  // 房仲拍照
  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot(); // base64 data
    // console.log(imageSrc)
    setVisitorPhoto(imageSrc);
  }, [webcamRef]);

  // 備註拍照
  const remarksCapture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot(); // base64 data
    // console.log(imageSrc)
    setVisitorRemarkPhoto(imageSrc);
  }, [webcamRef]);

  // 取得照相功能
  async function getWebcam() {
    await navigator.mediaDevices.getUserMedia({ audio: true, video: true }); // 強制打開聲音 影像
    const devices = await navigator.mediaDevices.enumerateDevices(); // 此裝置所有種類
    // console.log(devices)
    setDevices(devices.filter(({ kind }) => kind === 'videoinput')); // 選擇"videoinput"的種類
  }

  // 今日尚未離開房仲dataSource
  const dataSourceApproach = () => {
    let result = [];
    if (searchVisitorsName) {
      result = serachVisitorApproachNameArr;
    } else if (searchVisitorsCardNumber) {
      result = serachVisitorApproachArr;
    } else {
      result = currentPostsOut;
    }
    return result;
  };
  // 房仲預約清單dataSource
  const dataSourceAppointment = () => {
    let result = [];
    if (searchVisitorsName) {
      result = serachVisitorAppointmentNameArr;
    } else if (searchVisitorsCardNumber) {
      result = serachVisitorAppointmentArr;
    } else {
      result = currentPostsIn;
    }
    return result;
  };
  // 今日離開的房仲dataSource
  const dataSourceLeave = () => {
    let result = [];
    if (searchVisitorsName) {
      result = serachVisitorLeaveNameArr;
    } else if (searchVisitorsCardNumber) {
      result = serachVisitorLeaveArr;
    } else {
      result = currentPostsLeave;
    }
    return result;
  };

  // const funSortUpdate = (dataIndex, order) => {
  //   const rdataIndex = dataIndex || curdataIndex
  //   const rorder = order || curorder

  //   visitorAppointmentRegistration.find({}).then(res => {

  //     setVisitorAppointmentArr(res.data.sort((a, b) => {
  //       const result = (typeof a[rdataIndex] === "number" ? a[rdataIndex].toString() : a[rdataIndex]).localeCompare(typeof b[rdataIndex] === "number" ? b[rdataIndex].toString() : b[rdataIndex])
  //       return (rorder === 'asc') ? (result > 0 ? 1 : -1) : (result > 0 ? -1 : 1);
  //     }))

  //   })

  // }
  // const onTableSort = (dataIndex, order) => {
  //   console.log('==dataIndex:', dataIndex, 'order:', order);
  //   setcurDataIndex(dataIndex);
  //   setcurOrder(order);
  //   funSortUpdate(dataIndex, order);
  // }

  const disabledDate = (date, view) => {
    switch (view) {
      case 'date':
        return date.valueOf() <= currentDate1.valueOf();
      case 'year':
        return date.year() < currentDate.year();
      case 'month':
        return (
          date.year() * 100 + date.month() <
          currentDate.year() * 100 + currentDate.month()
        );
      default:
        return false;
    }
  };

  return (
    <>
      {/* 房仲拍照 */}
      <Dialog
        hasMask
        style={{ width: '700px' }}
        visible={webcamDialog}
        footerActions={['ok']}
        onOk={() => {
          setWebcamDialog(false);
        }}
        onCancel={() => {
          setWebcamDialog(false);
        }}
        onClose={() => {
          setWebcamDialog(false);
        }}
      >
        <div className={styles.selectBox}>
          <Select
            defaultValue="請選擇攝影機"
            dataSource={devices}
            onChange={(value, actionType, item) => {
              console.log(
                'value:',
                value,
                'item:',
                item.label,
                'actionType:',
                actionType
              );

              // console.log(devices.find(({ label }) => label === item.label))
              setDevicesVal([
                devices.find(({ label }) => label === item.label),
              ]);
            }}
          />

          <Button
            disabled={!devicesVal.length > 0}
            className={styles.takePitcher}
            type="normal"
            onClick={capture}
          >
            拍照
          </Button>
        </div>

        <div style={{ display: 'flex' }}>
          {devicesVal.length > 0
            ? devicesVal.map((device, index) => {
                return (
                  <div key={index}>
                    <Webcam
                      audio={false}
                      mirrore="true"
                      height={220}
                      ref={webcamRef}
                      screenshotFormat="image/jpeg"
                      videoConstraints={{ deviceId: device.deviceId }}
                    />
                  </div>
                );
              })
            : ''}
          {visitorPhoto && (
            <img
              style={{ height: '220px', marginLeft: '20px' }}
              src={visitorPhoto}
              alt=""
            />
          )}
        </div>
      </Dialog>
      {/* 備註拍照 */}
      <Dialog
        hasMask
        style={{ width: '700px' }}
        visible={webcamRemarksDialog}
        footerActions={['ok']}
        onOk={() => {
          setWebcamRemarksDialog(false);
        }}
        onCancel={() => {
          setWebcamRemarksDialog(false);
        }}
        onClose={() => {
          setWebcamRemarksDialog(false);
        }}
      >
        <div className={styles.selectBox}>
          <Select
            defaultValue="請選擇攝影機"
            dataSource={devices}
            onChange={(value, actionType, item) => {
              console.log(
                'value:',
                value,
                'item:',
                item.label,
                'actionType:',
                actionType
              );

              // console.log(devices.find(({ label }) => label === item.label))
              setDevicesVal([
                devices.find(({ label }) => label === item.label),
              ]);
            }}
          />

          <Button
            disabled={!devicesVal.length > 0}
            className={styles.takePitcher}
            type="normal"
            onClick={remarksCapture}
          >
            拍照
          </Button>
        </div>

        <div style={{ display: 'flex' }}>
          {devicesVal.length > 0
            ? devicesVal.map((device, index) => {
                return (
                  <div key={index}>
                    <Webcam
                      audio={false}
                      mirrore="true"
                      height={220}
                      ref={webcamRef}
                      screenshotFormat="image/jpeg"
                      videoConstraints={{ deviceId: device.deviceId }}
                    />
                  </div>
                );
              })
            : ''}
          {visitorRemarkPhoto && (
            <img
              style={{ height: '220px', marginLeft: '20px' }}
              src={visitorRemarkPhoto}
              alt=""
            />
          )}
        </div>
      </Dialog>

      {/* 房仲登記 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={addVisitorDialog}
        onOk={() => {
          if (!householdNumber) {
            Message.error('受訪人戶號請確實填寫');
          } else if (!visitorsName) {
            Message.error('房仲姓名請確實填寫');
          } else {
            if (carNumber.includes('-')) {
              Message.error('車牌號碼錯誤，請確認車牌不含(-)字眼');
              return;
            }
            Swal.fire({
              title: `確定新增房仲(${visitorsName})資料?`,
              text: '請確認資料無誤!!',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#BEBEBE',
              confirmButtonText: '確定',
              cancelButtonText: '取消',
            }).then((result) => {
              if (result.isConfirmed) {
                Swal.fire('成功!', '此房仲資料已建立', 'success');
                funCreateVisitor({
                  createdTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                  updatedTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                  reservationTimeStart: new Date(
                    reservationTimeStart.replace(' ', 'T')
                  ).getTime(),
                  visitorsName,
                  householdNumber,
                  temperature,
                  carNumber,
                  residentName,
                  visitorsPhone,
                  intervieweeRemarks,
                  visitingReason,
                  peopleNumber,
                  takeCardStatus,
                  visitorsStatus,
                  visitorPhoto,
                  visitorRemarkPhoto,
                  takeCardLost,
                  userId: tarUserId, // userID
                }).then(() => {
                  serverVisitorDataUpdate();
                  setReservationTimeStart(
                    moment().format('YYYY-MM-DD HH:mm:ss')
                  );
                  setVisitorsName('');
                  setVisitorsPhone('');
                  setResidentName('');
                  setTarUserId('');
                  setHouseholdNumber('');
                  setIntervieweeRemarks('');
                  setTemperature('');
                  setCarNumber('');
                  setVisitingReason('');
                  setPeopleNumber(1);
                  setVisitorPhoto(null);
                  setVisitorRemarkPhoto(null);
                  setAddVisitorDialog(false);
                });
              }
            });
          }
        }}
        onCancel={() => {
          setReservationTimeStart(moment().format('YYYY-MM-DD HH:mm:ss'));
          setVisitorsName('');
          setVisitorsPhone('');
          setResidentName('');
          setTarUserId('');
          setHouseholdNumber('');
          setIntervieweeRemarks('');
          setTemperature('');
          setCarNumber('');
          setVisitingReason('');
          setPeopleNumber(1);
          setVisitorPhoto(null);
          setVisitorRemarkPhoto(null);
          setAddVisitorDialog(false);
        }}
        onClose={() => {
          setReservationTimeStart(moment().format('YYYY-MM-DD HH:mm:ss'));
          setVisitorsName('');
          setVisitorsPhone('');
          setHouseholdNumber('');
          setResidentName('');
          setTarUserId('');
          setIntervieweeRemarks('');
          setTemperature('');
          setCarNumber('');
          setVisitingReason('');
          setPeopleNumber(1);
          setVisitorPhoto(null);
          setVisitorRemarkPhoto(null);
          setAddVisitorDialog(false);
        }}
      >
        <div>
          <h3>新增房仲預約及登記</h3>
          <Button
            type="secondary"
            onClick={() => {
              setWebcamDialog(true);
              getWebcam();
            }}
          >
            開啟房仲拍照
          </Button>
          <Image
            className={styles.photo}
            src={visitorPhoto || ezconImg}
            alt="房仲照片"
          />
          {/* <img
            className={styles.photo}
            src={
              visitorPhoto
                ? visitorPhoto
                : ezconImg
            }
            alt="房仲照片"
          ></img> */}

          <Form>
            <Form.Item required requiredMessage="必填" label="房仲姓名">
              <Input
                aria-required="true"
                name="visitorsName"
                placeholder="請輸入姓名"
                onChange={(value) => {
                  setVisitorsName(value);
                }}
              />
            </Form.Item>
            <Form.Item label="房仲電話">
              <Input
                name="Phone"
                placeholder="請輸入電話號碼"
                onChange={(value) => {
                  setVisitorsPhone(value);
                }}
              />
            </Form.Item>
            <Form.Item label="戶號和受訪人姓名" required requiredMessage="必填">
              <div className={styles.householdNumberBox}>
                <CascaderSelect
                  className={styles.cascaderSelect}
                  hasClear
                  // disabled={intervieweeName ? true : false}
                  name="householdNumber"
                  placeholder="請選擇戶號"
                  dataSource={ParseStringToArrayObject()}
                  value={householdNumber}
                  onChange={(value) => {
                    // console.log(value)

                    // 清除會變null 判斷有沒有值去找住戶member(陣列)
                    if (value !== null) {
                      users
                        .find({
                          query: {
                            householdNumbers: { $in: [value] },
                            f_password: { $exists: false },
                            expireTime: { $exists: false },
                          },
                        })
                        .then((res) => {
                          console.log(
                            '==users find householdNumber success:',
                            res.data[0]
                          );
                          setHouseholdNumber(value);
                          setResidentName('');
                          setTarUserId('');
                          // setResidentNameArr(res.data[0].members);
                          setResidentNameArr(
                            res.data.map((item) => {
                              return {
                                label: item.name,
                                value: item._id,
                              };
                            })
                          );
                        })
                        .catch((error) => {
                          console.log(
                            '==users find householdNumber fail:',
                            error
                          );
                        });
                    } else {
                      setHouseholdNumber('');
                      setResidentNameArr([]);
                      setResidentName('');
                      setTarUserId('');
                    }
                  }}
                />
                <Select
                  // hasClear
                  className={styles.selectName}
                  // disabled={intervieweeName || !householdNumber ? true : false}
                  disabled={!householdNumber}
                  placeholder="請先選擇戶號"
                  dataSource={residentNameArr}
                  value={residentName}
                  onChange={(value, actionType, item) => {
                    // console.log('vvv1' + value);
                    // setResidentName(value);
                    setResidentName(item.label);
                    setTarUserId(value);
                  }}
                />
              </div>
            </Form.Item>

            <Form.Item label="備註" help="可填寫房仲抵押證件、手機、鑰匙...等">
              <Input
                name="intervieweeRemarks"
                placeholder="請輸入受訪人資訊"
                onChange={(value) => {
                  setIntervieweeRemarks(value);
                }}
              />
            </Form.Item>
            <Button
              type="secondary"
              onClick={() => {
                setWebcamRemarksDialog(true);
                getWebcam();
              }}
            >
              拍照
            </Button>
            {/* <img
              className={styles.photo}
              src={
                visitorRemarkPhoto
                  ? visitorRemarkPhoto
                  : ezconImg
              }
              alt="房仲照片"
            ></img> */}
            <Image
              className={styles.photo}
              src={visitorRemarkPhoto || ezconImg}
              alt="房仲照片"
            />

            <Form.Item label="體溫">
              <Input
                name="temperature"
                placeholder="請輸入體溫"
                onChange={(value) => {
                  setTemperature(value);
                }}
              />
            </Form.Item>
            <Form.Item
              label="車牌號碼"
              help="請填寫車牌號碼不含'-'字眼，範例：GTR0857"
            >
              <Input
                value={carNumber}
                name="carNumber"
                placeholder="請輸入車牌號碼"
                onChange={(value) => {
                  setCarNumber(value.replace(/[\W]/g, ''));
                }}
              />
            </Form.Item>
            <Form.Item label="預約時間">
              {/* <h5>預約時間</h5> */}
              <DatePicker
                disabledDate={disabledDate}
                name="reservationTimeStart"
                value={reservationTimeStart}
                showTime
                onChange={(value) => {
                  setReservationTimeStart(value);
                }}
              />
            </Form.Item>
            <Form.Item label="人數">
              <Input
                value={peopleNumber}
                name="peopleNumber"
                placeholder="請輸入人數"
                onChange={(value) => {
                  setPeopleNumber(value.replace(/[^\d]/g, ''));
                }}
              />
            </Form.Item>
            <Form.Item label="拜訪原因">
              <Input.TextArea
                name="content"
                placeholder="請輸入內容"
                maxLength={100}
                rows={4}
                hasLimitHint
                aria-label="input max length 100"
                onChange={(value) => {
                  setVisitingReason(value);
                }}
              />
            </Form.Item>
          </Form>
        </div>
      </Dialog>

      {/* 入場 Dialog */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={takeCardDialog}
        footerActions={['ok']}
        onOk={() => {
          const item = currentPostsIn[takeCardIndex];
          item.visitorsStatus = '已入場';
          item.cardOrderNumber = cardOrderNumber;
          item.cardNumbering = cardNumbering;
          item.cardNotes = cardNotes;
          item.visitorPhoto = visitorPhoto;
          item.visitorRemarkPhoto = visitorRemarkPhoto;
          item.admissionTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          funUpdateVisitor(item._id, item).then(() => {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: '入場成功',
              showConfirmButton: false,
              timer: 1500,
            });
            const prePages = currentInPage - 1 >= 0 ? currentInPage - 1 : 0;
            if (visitorAppointmentArr.length - 1 <= prePages * postsPerPage) {
              setCurrentInPage(currentInPage - 1 < 1 ? 1 : currentInPage - 1);
            }

            // 20220309 入場後發推播給住戶
            axios('/ezcon/api/emitMsgQuery', {
              method: 'POST',
              headers: {
                authorization: window.localStorage['feathers-jwt'],
              },
              data: {
                service: 'message',
                event: 'msg',
                title: '房仲已入場',
                content: `房仲:${visitorsName},已入場`,
                type: 'success',
                class: 'visitorAppointmentRegistration',
                duration: 8000,
                redirect: '/ezpro/visitor/visitorAppointmentFrontDesk',
                query: {
                  householdNumbers: {
                    $in: [householdNumber],
                  },
                  firebaseClass: '房仲管理',
                },
              },
            })
              .then((res) => {
                console.log('==send message Success:', res);
                // Message.success('已傳送推播給住戶');
              })
              .catch((error) => {
                console.error('==send message fail:', error);
              });
            setReservationTimeStart(moment().format('YYYY-MM-DD HH:mm:ss'));
            setVisitorsName('');
            setHouseholdNumber('');
            setVisitingReason('');
            setPeopleNumber('');
            setCardNumber('');
            setCardOrderNumber('');
            setCardNumbering('');
            setCardNotes('');
            setVisitorPhoto('');
            setVisitorRemarkPhoto('');
            serverVisitorDataUpdate();
            serverLeaveDataUpdate();
            setTakeCardDialog(false);
          });
        }}
        onCancel={() => {
          setReservationTimeStart(moment().format('YYYY-MM-DD HH:mm:ss'));
          setVisitorsName('');
          setHouseholdNumber('');
          setVisitingReason('');
          setPeopleNumber('');
          setCardNumber('');
          setCardOrderNumber('');
          setCardNumbering('');
          setCardNotes('');
          setVisitorPhoto('');
          setVisitorRemarkPhoto('');
          setTakeCardDialog(false);
        }}
        onClose={() => {
          setReservationTimeStart(moment().format('YYYY-MM-DD HH:mm:ss'));
          setVisitorsName('');
          setHouseholdNumber('');
          setVisitingReason('');
          setPeopleNumber('');
          setCardNumber('');
          setCardOrderNumber('');
          setCardNumbering('');
          setCardNotes('');
          setVisitorPhoto('');
          setVisitorRemarkPhoto('');
          setTakeCardDialog(false);
        }}
      >
        <h2>房仲入場</h2>
        <div style={{ display: 'flex' }}>
          <Form.Item label="房仲姓名">{visitorsName}</Form.Item>

          <Button
            style={{ marginLeft: '10px' }}
            type="secondary"
            onClick={() => {
              setWebcamDialog(true);
              getWebcam();
            }}
          >
            開啟房仲拍照
          </Button>
          <Image
            className={styles.photo}
            src={visitorPhoto || ezconImg}
            alt="房仲照片"
          />
        </div>

        <Form.Item label="戶號">{householdNumber}</Form.Item>
        <Form.Item label="人數">{peopleNumber}</Form.Item>
        <Form.Item label="拜訪原因">{visitingReason}</Form.Item>
        <Form.Item label="相關證件照片">
          <Button
            type="secondary"
            onClick={() => {
              setWebcamRemarksDialog(true);
              getWebcam();
            }}
          >
            拍照
          </Button>
          <Image
            className={styles.photo}
            src={visitorRemarkPhoto || ezconImg}
            alt="房仲照片"
          />
        </Form.Item>

        <Form.Item label="卡片流水號">
          <Input
            name="cardOrderNumber"
            placeholder="請輸入卡片流水號"
            onChange={(value) => {
              setCardOrderNumber(value);
            }}
          />
        </Form.Item>
        <Form.Item label="卡片編號(自行命名)">
          <Input
            name="cardNumbering"
            placeholder="請輸入卡片編號"
            onChange={(value) => {
              setCardNumbering(value);
            }}
          />
        </Form.Item>
        <Form.Item label="卡片備註">
          <Input
            name="cardNotes"
            placeholder="請輸入卡片備註"
            onChange={(value) => {
              setCardNotes(value);
            }}
          />
        </Form.Item>
      </Dialog>

      {/* 離場 Dialog */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={leaveDialog}
        footerActions={['ok']}
        onOk={() => {
          setVisitorsStatus('預約中');

          const item = currentPostsOut[leaveIndex];

          item.visitorsStatus = '已離場';
          item.leaveTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          funUpdateVisitor(item._id, item).then(() => {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: '離開成功',
              showConfirmButton: false,
              timer: 1500,
            });
            const prePages = currentOutPage - 1 >= 0 ? currentOutPage - 1 : 0;
            if (leaveArr.length - 1 <= prePages * postsPerPage) {
              setCurrentOutPage(
                currentOutPage - 1 < 1 ? 1 : currentOutPage - 1
              );
            }
            serverVisitorDataUpdate();
            serverLeaveDataUpdate();
            serverLeaveDataUpdate1();
            setLeaveDialog(false);
          });
        }}
        onCancel={() => {
          setVisitorsStatus('');
          // setCardNumber('');
          setLeaveDialog(false);
        }}
        onClose={() => {
          setVisitorsStatus('');
          // setCardNumber('');
          setLeaveDialog(false);
        }}
      >
        <h2>房仲離場確認，並歸還相關證件給房仲!!</h2>
        <Form.Item label="卡片流水號">{cardOrderNumber}</Form.Item>
        <Form.Item label="卡片編號(自行命名)">{cardNumbering}</Form.Item>
        <Form.Item label="卡片備註">{cardNotes}</Form.Item>
      </Dialog>

      {/* 編輯 Dialog */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={editVisitorDialog}
        onOk={() => {
          if (!householdNumber) {
            Message.error('受訪人戶號請確實填寫');
          } else {
            if (carNumber.includes('-')) {
              Message.error('車牌號碼錯誤，請確認車牌不含(-)字眼');
              return;
            }

            Swal.fire({
              title: `確定修改房仲(${visitorsName})資料?`,
              text: '請確認修改資料!!',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#BEBEBE',
              confirmButtonText: '確定',
              cancelButtonText: '取消',
            }).then((result) => {
              if (result.isConfirmed) {
                Swal.fire('成功!', '此房仲修改成功', 'success');
                const item = currentPostsIn[editVisitorIndex];
                (item.reservationTimeStart = new Date(
                  reservationTimeStart.replace(' ', 'T')
                ).getTime()),
                  (item.visitorsName = visitorsName);
                item.visitorsPhone = visitorsPhone;
                item.householdNumber = householdNumber;
                item.residentName = residentName;
                item.intervieweeRemarks = intervieweeRemarks;
                item.temperature = temperature;
                item.carNumber = carNumber;
                item.visitingReason = visitingReason;
                item.peopleNumber = peopleNumber;
                item.visitorPhoto = visitorPhoto;
                item.visitorRemarkPhoto = visitorRemarkPhoto;
                item.updatedTime = moment(new Date()).format(
                  'YYYY-MM-DD HH:mm:ss'
                );
                funUpdateVisitor(item._id, item).then(() => {
                  serverVisitorDataUpdate();
                  setEditVisitorDialog(false);
                  setReservationTimeStart(
                    moment().format('YYYY-MM-DD HH:mm:ss')
                  );
                  setVisitorsName('');
                  setVisitorsPhone('');
                  setHouseholdNumber('');
                  setResidentName('');
                  setTarUserId('');
                  setIntervieweeRemarks('');
                  setTemperature('');
                  setCarNumber('');
                  setVisitingReason('');
                  setPeopleNumber('');
                  setVisitorPhoto('');
                  setVisitorRemarkPhoto('');
                });
              }
            });
          }
        }}
        onCancel={() => {
          setReservationTimeStart(moment().format('YYYY-MM-DD HH:mm:ss'));
          setVisitorsName('');
          setVisitorsPhone('');
          setHouseholdNumber('');
          setResidentName('');
          setTarUserId('');
          setIntervieweeRemarks('');
          setTemperature('');
          setCarNumber('');
          setVisitingReason('');
          setPeopleNumber('');
          setVisitorPhoto('');
          setVisitorRemarkPhoto('');
          setEditVisitorDialog(false);
        }}
        onClose={() => {
          setReservationTimeStart(moment().format('YYYY-MM-DD HH:mm:ss'));
          setVisitorsName('');
          setVisitorsPhone('');
          setHouseholdNumber('');
          setResidentName('');
          setTarUserId('');
          setIntervieweeRemarks('');
          setTemperature('');
          setCarNumber('');
          setVisitingReason('');
          setPeopleNumber('');
          setVisitorPhoto('');
          setVisitorRemarkPhoto('');
          setEditVisitorDialog(false);
        }}
      >
        <h3>編輯房仲預約及登記</h3>
        <Button
          type="secondary"
          onClick={() => {
            setWebcamEditDialog(true);
            getWebcam();
          }}
        >
          編輯房仲照片
        </Button>
        <Dialog
          hasMask
          style={{ width: '700px' }}
          visible={webcamEditDialog}
          footerActions={['ok']}
          onOk={() => {
            setWebcamEditDialog(false);
          }}
          onCancel={() => {
            setWebcamEditDialog(false);
          }}
          onClose={() => {
            setWebcamEditDialog(false);
          }}
        >
          <div className={styles.selectBox}>
            <Select
              defaultValue="請選擇攝影機"
              dataSource={devices}
              onChange={(value, actionType, item) => {
                console.log(
                  'value:',
                  value,
                  'item:',
                  item.label,
                  'actionType:',
                  actionType
                );

                // console.log(devices.find(({ label }) => label === item.label))
                setDevicesVal([
                  devices.find(({ label }) => label === item.label),
                ]);
              }}
            />

            <Button
              disabled={!devicesVal.length > 0}
              className={styles.takePitcher}
              type="normal"
              onClick={capture}
            >
              拍照
            </Button>
          </div>

          <div style={{ display: 'flex' }}>
            {devicesVal.length > 0
              ? devicesVal.map((device, index) => {
                  return (
                    <div key={index}>
                      <Webcam
                        audio={false}
                        mirrore="true"
                        height={220}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        videoConstraints={{
                          deviceId: device.deviceId,
                        }}
                      />
                    </div>
                  );
                })
              : ''}
            {visitorPhoto && (
              <img
                style={{ height: '220px', marginLeft: '20px' }}
                src={visitorPhoto}
              />
            )}
          </div>
        </Dialog>

        {/* <img
          className={styles.photo}
          src={
            visitorPhoto
              ? visitorPhoto
              : ezconImg
          }
          alt="房仲照片"
        ></img> */}
        <Image
          className={styles.photo}
          src={visitorPhoto || ezconImg}
          alt="房仲照片"
        />
        <Form.Item label="房仲姓名">
          <Input
            name="visitorsName"
            placeholder="請輸入姓名"
            value={visitorsName}
            onChange={(value) => {
              setVisitorsName(value);
            }}
          />
        </Form.Item>
        <Form.Item label="房仲電話">
          <Input
            name="visitorsPhone"
            placeholder="請輸入電話號碼"
            value={visitorsPhone}
            onChange={(value) => {
              setVisitorsPhone(value);
            }}
          />
        </Form.Item>
        <Form.Item required requiredMessage="必填" label="戶號和受訪人姓名">
          <div className={styles.householdNumberBox}>
            <CascaderSelect
              className={styles.cascaderSelect}
              hasClear
              // disabled={intervieweeName ? true : false}
              name="householdNumber"
              placeholder="請選擇戶號"
              dataSource={ParseStringToArrayObject()}
              value={householdNumber}
              onChange={(value) => {
                // console.log(value)

                // 清除會變null 判斷有沒有值去找住戶member(陣列)
                if (value !== null) {
                  users
                    .find({
                      query: {
                        householdNumbers: { $in: [value] },
                        f_password: { $exists: false },
                        expireTime: { $exists: false },
                      },
                    })
                    .then((res) => {
                      console.log(
                        '==users find householdNumber success:',
                        res.data[0]
                      );
                      setHouseholdNumber(value);
                      setResidentName('');
                      setTarUserId('');
                      // setResidentNameArr(res.data[0].members);
                      setResidentNameArr(
                        res.data.map((item) => {
                          return {
                            label: item.name,
                            value: item._id,
                          };
                        })
                      );
                    })
                    .catch((error) => {
                      console.log(
                        '==residentAccountNumbers find householdNumber fail:',
                        error
                      );
                    });
                } else {
                  setHouseholdNumber('');
                  setResidentNameArr([]);
                  setResidentName('');
                  setTarUserId('');
                }
              }}
            />
            <Select
              // hasClear
              className={styles.selectName}
              // disabled={intervieweeName || !householdNumber ? true : false}
              disabled={!householdNumber}
              placeholder="請先選擇戶號"
              dataSource={residentNameArr}
              value={residentName}
              onChange={(value, actionType, item) => {
                console.log(`vvv2${value}`);
                // setResidentName(value);
                setResidentName(item.label);
                setTarUserId(value);
              }}
            />
          </div>
        </Form.Item>

        <Form.Item label="備註" help="可填寫房仲抵押證件、手機、鑰匙...等">
          <Input
            value={intervieweeRemarks}
            name="intervieweeRemarks"
            placeholder="請輸入受訪人資訊"
            onChange={(value) => {
              setIntervieweeRemarks(value);
            }}
          />
        </Form.Item>
        <Button
          type="secondary"
          onClick={() => {
            setWebcamEditRemarksDialog(true);
            getWebcam();
          }}
        >
          拍照
        </Button>
        <Image
          className={styles.photo}
          src={visitorRemarkPhoto || ezconImg}
          alt="房仲照片"
        />
        {/* <img
          className={styles.photo}
          src={
            visitorRemarkPhoto
              ? visitorRemarkPhoto
              : ezconImg
          }
          alt="房仲照片"
        ></img> */}

        <Dialog
          hasMask
          style={{ width: '700px' }}
          visible={webcamEditRemarksDialog}
          footerActions={['ok']}
          onOk={() => {
            setWebcamEditRemarksDialog(false);
          }}
          onCancel={() => {
            setWebcamEditRemarksDialog(false);
          }}
          onClose={() => {
            setWebcamEditRemarksDialog(false);
          }}
        >
          <div className={styles.selectBox}>
            <Select
              defaultValue="請選擇攝影機"
              dataSource={devices}
              onChange={(value, actionType, item) => {
                console.log(
                  'value:',
                  value,
                  'item:',
                  item.label,
                  'actionType:',
                  actionType
                );

                // console.log(devices.find(({ label }) => label === item.label))
                setDevicesVal([
                  devices.find(({ label }) => label === item.label),
                ]);
              }}
            />

            <Button
              disabled={!devicesVal.length > 0}
              className={styles.takePitcher}
              type="normal"
              onClick={remarksCapture}
            >
              拍照
            </Button>
          </div>

          <div style={{ display: 'flex' }}>
            {devicesVal.length > 0
              ? devicesVal.map((device, index) => {
                  return (
                    <div key={index}>
                      <Webcam
                        audio={false}
                        mirrore="true"
                        height={220}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        videoConstraints={{ deviceId: device.deviceId }}
                      />
                    </div>
                  );
                })
              : ''}
            {visitorRemarkPhoto && (
              <img
                style={{ height: '220px', marginLeft: '20px' }}
                src={visitorRemarkPhoto}
              />
            )}
          </div>
        </Dialog>

        <Form.Item label="體溫">
          <Input
            value={temperature}
            name="temperature"
            placeholder="請輸入體溫"
            onChange={(value) => {
              setTemperature(value);
            }}
          />
        </Form.Item>
        <Form.Item
          label="車牌號碼"
          help="請填寫車牌號碼不含'-'字眼，範例：GTR0857"
        >
          <Input
            value={carNumber}
            name="carNumber"
            placeholder="請輸入車牌號碼"
            onChange={(value) => {
              setCarNumber(value.replace(/[\W]/g, ''));
            }}
          />
        </Form.Item>
        <Form.Item label="預約時間">
          {/* <h5>預約時間</h5> */}
          <DatePicker
            disabledDate={disabledDate}
            showTime
            value={reservationTimeStart}
            onChange={(value) => {
              setReservationTimeStart(value);
            }}
          />
        </Form.Item>
        <Form.Item label="人數">
          <Input
            value={peopleNumber}
            name="peopleNumber"
            placeholder="請輸入人數"
            onChange={(value) => {
              setPeopleNumber(value.replace(/[^\d]/g, ''));
            }}
          />
        </Form.Item>
        <Form.Item label="拜訪原因">
          <Input.TextArea
            value={visitingReason}
            name="content"
            placeholder="請輸入內容"
            maxLength={100}
            rows={4}
            hasLimitHint
            aria-label="input max length 100"
            onChange={(value) => {
              setVisitingReason(value);
            }}
          />
        </Form.Item>
      </Dialog>

      <div className={styles.searchVisitorsCardBox}>
        <div>
          <Button
            className={styles.buttonAdd}
            onClick={() => {
              setAddVisitorDialog(true);
            }}
          >
            房仲登記
          </Button>

          <h3>搜尋房仲</h3>
          <Input
            placeholder="請輸入房仲姓名"
            onChange={(value) => {
              setSearchVisitorsName(value);
            }}
          />
        </div>
      </div>

      {/* 今日尚未離開房仲 */}

      <Card free className={styles.card}>
        <Card.Content>
          <h1>今日尚未離開房仲有{currentDateAdmission.length}人</h1>
          <Table dataSource={dataSourceApproach()}>
            {/* <Table.Column
              title="流水號"
              width={100}
              lock='left'
              cell={(value, index, record) => {
                return (
                  index
                )
              }} /> */}

            <Table.Column
              title="來訪時間"
              dataIndex="admissionTime"
              width={200}
            />
            <Table.Column
              title="房仲姓名"
              dataIndex="visitorsName"
              width={200}
            />
            <Table.Column
              title="房仲照片"
              width={200}
              dataIndex="visitorPhoto"
              cell={(value, index, record) => {
                // console.log('==op ', value, index, record);

                return (
                  <>
                    {record ? (
                      <Image
                        className={styles.visitorPhoto}
                        src={
                          currentPostsOut[index].visitorPhoto
                            ? currentPostsOut[index].visitorPhoto
                            : ezconImg
                        }
                        alt="房仲照片"
                      />
                    ) : (
                      ''
                    )}
                  </>
                );
              }}
            />
            <Table.Column
              title="房仲電話"
              dataIndex="visitorsPhone"
              width={200}
            />
            <Table.Column
              title="戶號"
              dataIndex="householdNumber"
              width={200}
            />
            <Table.Column
              title="此戶號姓名"
              dataIndex="residentName"
              width={200}
            />
            <Table.Column
              title="備註"
              dataIndex="intervieweeRemarks"
              width={200}
            />
            <Table.Column
              title="照片"
              width={200}
              dataIndex="visitorRemarkPhoto"
              cell={(value, index, record) => {
                // console.log('==op ', value, index, record);

                return (
                  <>
                    {record ? (
                      <Image
                        className={styles.visitorPhoto}
                        src={
                          currentPostsOut[index].visitorRemarkPhoto
                            ? currentPostsOut[index].visitorRemarkPhoto
                            : ezconImg
                        }
                        alt="照片"
                      />
                    ) : (
                      ''
                    )}
                  </>
                );
              }}
            />
            <Table.Column title="體溫" dataIndex="temperature" width={200} />
            <Table.Column title="車牌號碼" dataIndex="carNumber" width={200} />
            <Table.Column
              title="拜訪原因"
              dataIndex="visitingReason"
              width={200}
            />
            <Table.Column title="人數" dataIndex="peopleNumber" width={200} />

            <Table.Column
              title="房仲狀態"
              dataIndex="visitorsStatus"
              width={200}
            />

            <Table.Column
              lock="right"
              title="操作"
              width={100}
              cell={(value, index, record) => {
                // console.log('==op ', value, index, record);
                return (
                  <div>
                    {/* 離場 */}
                    <Button
                      className={styles.buttonEdit}
                      type="secondary"
                      onClick={() => {
                        setVisitorsStatus(
                          currentPostsOut[index].visitorsStatus
                        );

                        setLeaveIndex(index);
                        setLeaveDialog(true);
                        setCardOrderNumber(
                          currentPostsOut[index].cardOrderNumber
                        );
                        setCardNumbering(currentPostsOut[index].cardNumbering);
                        setCardNotes(currentPostsOut[index].cardNotes);
                      }}
                    >
                      離場
                    </Button>
                  </div>
                );
              }}
            />
          </Table>
          <Pagination
            className={styles.pagination}
            total={leaveArr.length}
            pageSize={postsPerPage}
            totalRender={(total) => `Total: ${total}`}
            onChange={(pageNumber) => {
              setCurrentOutPage(pageNumber);
            }}
          />
        </Card.Content>
      </Card>

      {/* 房仲預約清單 */}
      <Card free className={styles.card}>
        <Card.Content>
          <h1>房仲預約清單</h1>
          <Table dataSource={dataSourceAppointment()}>
            {/* <Table.Column
              title="流水號"
              width={100}
              lock='left'
              cell={(value, index, record) => {
                return (
                  index
                )
              }} /> */}

            <Table.Column
              title="預約時間"
              width={200}
              cell={(value, index, record) => {
                return moment(
                  dataSourceAppointment()[index].reservationTimeStart
                ).format('YYYY-MM-DD HH:mm:ss');
              }}
            />
            <Table.Column
              title="房仲姓名"
              dataIndex="visitorsName"
              width={200}
            />
            <Table.Column
              title="房仲照片"
              width={200}
              dataIndex="visitorPhoto"
              cell={(value, index, record) => {
                // console.log('==op ', value, index, record);

                return (
                  <>
                    {record ? (
                      <Image
                        className={styles.visitorPhoto}
                        src={
                          currentPostsIn[index].visitorPhoto
                            ? currentPostsIn[index].visitorPhoto
                            : ezconImg
                        }
                        alt="房仲照片"
                      />
                    ) : (
                      ''
                    )}
                  </>
                );
              }}
            />

            <Table.Column
              title="房仲電話"
              dataIndex="visitorsPhone"
              width={200}
            />
            <Table.Column
              title="戶號"
              dataIndex="householdNumber"
              width={200}
            />
            <Table.Column
              title="此戶號姓名"
              dataIndex="residentName"
              width={200}
            />
            <Table.Column
              title="備註"
              dataIndex="intervieweeRemarks"
              width={200}
            />

            <Table.Column
              title="照片"
              width={200}
              dataIndex="visitorRemarkPhoto"
              cell={(value, index, record) => {
                // console.log('==op ', value, index, record);

                return (
                  <>
                    {record ? (
                      <Image
                        className={styles.visitorPhoto}
                        src={
                          currentPostsIn[index].visitorRemarkPhoto
                            ? currentPostsIn[index].visitorRemarkPhoto
                            : ezconImg
                        }
                        alt="照片"
                      />
                    ) : (
                      ''
                    )}
                  </>
                );
              }}
            />
            <Table.Column title="體溫" dataIndex="temperature" width={200} />
            <Table.Column title="車牌號碼" dataIndex="carNumber" width={200} />
            <Table.Column
              title="拜訪原因"
              dataIndex="visitingReason"
              width={200}
            />
            <Table.Column title="人數" dataIndex="peopleNumber" width={200} />

            <Table.Column
              title="房仲狀態"
              dataIndex="visitorsStatus"
              width={200}
            />

            <Table.Column
              lock="right"
              title="操作"
              width={300}
              cell={(value, index, record) => {
                // console.log('==op ', value, index, record);
                return (
                  <div className={styles.btn}>
                    <Button
                      type="normal"
                      onClick={() => {
                        setReservationTimeStart(
                          moment(
                            currentPostsIn[index].reservationTimeStart
                          ).format('YYYY-MM-DD HH:mm:ss')
                        );
                        setVisitorsName(currentPostsIn[index].visitorsName);
                        setVisitorsPhone(currentPostsIn[index].visitorsPhone);
                        setHouseholdNumber(
                          currentPostsIn[index].householdNumber
                        );
                        setResidentName(currentPostsIn[index].residentName);

                        setIntervieweeRemarks(
                          currentPostsIn[index].intervieweeRemarks
                        );
                        setTemperature(currentPostsIn[index].temperature);
                        setCarNumber(currentPostsIn[index].carNumber);
                        setVisitingReason(currentPostsIn[index].visitingReason);
                        setPeopleNumber(currentPostsIn[index].peopleNumber);
                        setVisitorPhoto(currentPostsIn[index].visitorPhoto);
                        setVisitorRemarkPhoto(
                          currentPostsIn[index].visitorRemarkPhoto
                        );
                        setEditVisitorIndex(index);
                        setEditVisitorDialog(true);

                        residentAccountNumbers
                          .find({
                            query: {
                              householdNumber:
                                currentPostsIn[index].householdNumber,
                            },
                          })
                          .then((res) => {
                            console.log(
                              '==residentAccountNumbers find householdNumber success:',
                              res.data[0]
                            );
                            setResidentNameArr(res.data[0].members);
                          })
                          .catch((error) => {
                            console.log(
                              '==residentAccountNumbers find householdNumber fail:',
                              error
                            );
                          });

                        users
                          .find({
                            query: {
                              householdNumbers: {
                                $in: [record.householdNumber],
                              },
                              f_password: { $exists: false },
                              expireTime: { $exists: false },
                            },
                          })
                          .then((res) => {
                            console.log(
                              '==users find householdNumber success:',
                              res.data[0]
                            );

                            // setResidentNameArr(res.data[0].members);
                            setResidentNameArr(
                              res.data.map((item) => {
                                return {
                                  label: item.name,
                                  value: item._id,
                                };
                              })
                            );
                          })
                          .catch((error) => {
                            console.log(
                              '==users find householdNumber fail:',
                              error
                            );
                          });
                      }}
                    >
                      編輯
                    </Button>

                    {/* 取消預約 */}
                    <Button
                      className={styles.buttonEdit}
                      type="secondary"
                      onClick={() => {
                        const item = currentPostsIn[index];

                        item.visitorsStatus = '已取消';
                        item.cancleTime = moment(new Date()).format(
                          'YYYY-MM-DD HH:mm:ss'
                        );

                        Swal.fire({
                          title: `確定取消房仲(${item.visitorsName})預約?`,
                          text: '取消後將無法復原!!',
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#BEBEBE',
                          confirmButtonText: '確定',
                          cancelButtonText: '取消',
                        }).then((result) => {
                          if (result.isConfirmed) {
                            Swal.fire('成功!', '此房仲取消成功', 'success');

                            funUpdateVisitor(item._id, item).then(() => {
                              const prePages =
                                currentInPage - 1 >= 0 ? currentInPage - 1 : 0;
                              if (
                                visitorAppointmentArr.length - 1 <=
                                prePages * postsPerPage
                              ) {
                                setCurrentInPage(
                                  currentInPage - 1 < 1 ? 1 : currentInPage - 1
                                );
                              }

                              serverVisitorDataUpdate();
                            });
                          }
                        });
                      }}
                    >
                      取消預約
                    </Button>

                    {/* 入場 */}
                    <Button
                      className={styles.buttonEdit}
                      type="primary"
                      onClick={() => {
                        setReservationTimeStart(
                          moment(
                            currentPostsIn[index].reservationTimeStart
                          ).format('YYYY-MM-DD HH:mm:ss')
                        );
                        setVisitorsName(currentPostsIn[index].visitorsName);
                        setHouseholdNumber(
                          currentPostsIn[index].householdNumber
                        );
                        setVisitingReason(currentPostsIn[index].visitingReason);
                        setPeopleNumber(currentPostsIn[index].peopleNumber);
                        setVisitorsStatus(currentPostsIn[index].visitorsStatus);
                        setVisitorPhoto(currentPostsIn[index].visitorPhoto);
                        setVisitorRemarkPhoto(
                          currentPostsIn[index].visitorRemarkPhoto
                        );
                        setTakeCardIndex(index);
                        setTakeCardDialog(true);
                      }}
                    >
                      入場
                    </Button>
                  </div>
                );
              }}
            />
          </Table>
          <Pagination
            className={styles.pagination}
            total={visitorAppointmentArr.length}
            pageSize={postsPerPage}
            totalRender={(total) => `Total: ${total}`}
            onChange={(pageNumber) => {
              setCurrentInPage(pageNumber);
            }}
          />
        </Card.Content>
      </Card>

      {/* 今日已離開房仲 */}
      <Card free className={styles.card}>
        <Card.Content>
          <h1>今日離開的房仲有{currentDateLeave.length}人</h1>
          <Table
            dataSource={dataSourceLeave()}
            // onSort={onTableSort}
          >
            {/* <Table.Column
              title="流水號"
              width={100}
              lock='left'
              cell={(value, index, record) => {
                return (
                  index
                )
              }} /> */}

            <Table.Column
              title="來訪時間"
              dataIndex="admissionTime"
              width={200}
            />
            <Table.Column title="離開時間" dataIndex="leaveTime" width={200} />
            <Table.Column
              title="房仲姓名"
              dataIndex="visitorsName"
              width={200}
            />
            <Table.Column
              title="房仲照片"
              width={200}
              dataIndex="visitorPhoto"
              cell={(value, index, record) => {
                // console.log('==op ', value, index, record);

                return (
                  <>
                    {record ? (
                      <Image
                        className={styles.visitorPhoto}
                        src={
                          currentPostsLeave[index].visitorPhoto
                            ? currentPostsLeave[index].visitorPhoto
                            : ezconImg
                        }
                        alt="房仲照片"
                      />
                    ) : (
                      ''
                    )}
                  </>
                );
              }}
            />
            <Table.Column
              title="房仲電話"
              dataIndex="visitorsPhone"
              width={200}
            />
            <Table.Column
              title="戶號"
              dataIndex="householdNumber"
              width={200}
            />
            <Table.Column
              title="此戶號姓名"
              dataIndex="residentName"
              width={200}
            />
            <Table.Column
              title="備註"
              dataIndex="intervieweeRemarks"
              width={200}
            />
            <Table.Column
              title="照片"
              width={200}
              dataIndex="visitorRemarkPhoto"
              cell={(value, index, record) => {
                // console.log('==op ', value, index, record);

                return (
                  <>
                    {record ? (
                      <Image
                        className={styles.visitorPhoto}
                        src={
                          currentPostsLeave[index].visitorRemarkPhoto
                            ? currentPostsLeave[index].visitorRemarkPhoto
                            : ezconImg
                        }
                        alt="照片"
                      />
                    ) : (
                      ''
                    )}
                  </>
                );
              }}
            />
            <Table.Column title="體溫" dataIndex="temperature" width={200} />
            <Table.Column title="車牌號碼" dataIndex="carNumber" width={200} />
            <Table.Column
              title="拜訪原因"
              dataIndex="visitingReason"
              width={200}
            />
            <Table.Column title="人數" dataIndex="peopleNumber" width={200} />

            <Table.Column
              title="房仲狀態"
              dataIndex="visitorsStatus"
              width={200}
            />
          </Table>
          <Pagination
            className={styles.pagination}
            total={leaveArr1.length}
            pageSize={postsPerPage}
            totalRender={(total) => `Total: ${total}`}
            onChange={(pageNumber) => {
              setCurrentLeavePage(pageNumber);
            }}
          />
        </Card.Content>
      </Card>
    </>
  );
};

export default RealEstateAgentManagementList;
